export const MAX_DEPARTMENT_LABEL_LENGTH = 40;
export const MAX_DEPARTMENTS = 8;

export type DepartmentOption = { key: string; label: string };

export const DEFAULT_DEPARTMENTS: DepartmentOption[] = [
  { key: 'developpeur', label: 'Développeur' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'rh', label: 'RH' },
  { key: 'direction', label: 'Direction' },
  { key: 'support', label: 'Support' },
];

export function defaultDepartmentOptions(): DepartmentOption[] {
  return DEFAULT_DEPARTMENTS.map((dept) => ({ ...dept }));
}

export function getDepartmentLabel(
  key: string | null | undefined,
  departments: DepartmentOption[] = DEFAULT_DEPARTMENTS
): string {
  if (!key) return 'Non défini';
  return departments.find((dept) => dept.key === key)?.label ?? key;
}
